import { RouterProvider, type RouterProviderProps } from 'react-router';

import type { AppServices } from './boot';
import { AppProviders } from './providers';

export type AppProps = { services: AppServices; router: RouterProviderProps['router'] };

export const App = ({ services, router }: AppProps) => (
  <AppProviders services={services}>
    <RouterProvider router={router} />
  </AppProviders>
);
